import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import toastr from "toastr";
import { authFetch } from "../utils/authFetch";

function Commission() {
  const { schemeId } = useParams();
  const [commissions, setCommissions] = useState([]);
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({});

  const showToast = (msg, type = "success") => {
    toastr.options = {
      closeButton: true,
      progressBar: true,
      timeOut: 3000,
      positionClass: "toast-top-right",
    };
    toastr[type](msg);
  };

  // 🔄 Load existing commissions
  const fetchCommissions = async () => {
    try {
      // const res = await fetch(`http://127.0.0.1:6060/api/v1/commission/list/${schemeId}`, {
      //   headers: {
      //     Authorization: `Bearer ${localStorage.getItem("token")}`,
      //   },
      // });
      // if (!res.ok) throw new Error("Failed to fetch commissions");
      const res = await authFetch(`/api/v1/commission/list/${schemeId}`);
      if (!res) return;
      const data = await res.json();
      setCommissions(data);

      const initialValues = {};
      data.forEach((c) => {
        // GroupType guess karo from provider list
        const provider = providers.find((p) => p._id === c.slab || p.id === c.slab);
        const groupType = c.groupType || "payin";
        //const groupType = provider?.type || "payin"; // default

        const key = `${c.slab}_${groupType}`;
        initialValues[key] = {
            type: c.type || "",
            apiuser: c.apiuser || "",
            groupType: c.groupType,
            id: c._id || c.id || null,
            gst_percent: c.gst_percent || 18,
        };
        });
      console.log("Fetched Commissions:", data);
      console.log("Pre-filled formValues:", initialValues);
      setFormValues(initialValues);
    } catch (err) {
      showToast(err.message || "Failed to load commissions", "error");
    }
  };

  // 🔄 Load provider list
  const fetchProviders = async () => {
    try {
      // const res = await fetch("http://127.0.0.1:6060/api/v1/provider/list", {
      //   headers: {
      //     Authorization: `Bearer ${localStorage.getItem("token")}`,
      //   },
      // });
      const res = await authFetch("/api/v1/provider/list");
      if (!res) return;

      if (!res.ok) throw new Error("Failed to fetch providers");
      const data = await res.json();
      setProviders(data);
    } catch (err) {
      showToast(err.message || "Failed to load providers", "error");
    }
  };

  useEffect(() => {
    if (schemeId) {
        fetchProviders();
    }
    }, [schemeId]);

    useEffect(() => {
    if (schemeId && providers.length > 0) {
        fetchCommissions();
    }
    }, [providers]);


  // 🧠 Input change
  const handleInputChange = (slabId, groupType, field, value) => {
    const key = `${slabId}_${groupType}`;
    setFormValues((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
  };

  // 🧾 Submit handler
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const entries = [];

      providers.forEach((provider) => {
        const groupType = provider.type;
        // const groupType = val.groupType || provider.type;
        // const groupType = (formValues[`${slabId}_${provider.type}`]?.groupType) || provider.type;
        const slabId = provider._id || provider.id;
        const key = `${slabId}_${groupType}`;
        const val = formValues[key];

        if (!val || !val.type || !val.apiuser) return;

        entries.push({
          id: val.id || null,
          type: val.type,
          slab: slabId,
          // groupType,
          groupType: val.groupType || provider.type,
          apiuser: val.apiuser,
          scheme_id: schemeId,
          gst_percent: val.gst_percent || 18,
        });
      });

      for (const entry of entries) {
        const url = entry.id
          ? `/api/v1/commission/update/${entry.id}/${schemeId}`
          : "/api/v1/commission/create";
        const method = entry.id ? "PUT" : "POST";

        const res = await authFetch(url, {
          method,
          // headers: {
          //   "Content-Type": "application/json",
          //   Authorization: `Bearer ${localStorage.getItem("token")}`,
          // },
          body: JSON.stringify(entry),
        });

        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(errorData.detail || "Error saving commission");
        }
      }

      showToast("Saved successfully");
      await fetchCommissions();
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // 🧾 Table render
  const renderTable = (groupType, title, colorClass) => (
    <div className="card mb-4">
      <div className={`card-header bg-light text-${colorClass}`}>
        <h5 className="mb-0">{title}</h5>
      </div>
      <div className="card-body table-responsive">
        <table className="table table-bordered mb-0">
          <thead>
            <tr>
              <th>Provider</th>
              <th>Commission Type</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {providers.filter((p) => p.type === groupType).map((provider) => {
              const slabId = provider._id || provider.id;
              const key = `${slabId}_${groupType}`;
              const val = formValues[key] || { type: "", apiuser: "" };

              return (
                <tr key={key}>
                  <td>{provider.name} - {provider.plan}</td>
                  <td>
                    <select
                      className="form-control"
                      value={val.type || ""}
                      onChange={(e) =>
                        handleInputChange(slabId, groupType, "type", e.target.value)
                      }
                    >
                      <option value="">Select</option>
                      <option value="percent">Percent (%)</option>
                      <option value="flat">Flat (Rs)</option>
                    </select>
                  </td>
                  <td>
                    <label className="form-label">Charges </label>
                    <input
                      type="number"
                      step="any"
                      className="form-control"
                      placeholder="Enter Value"
                      value={val.apiuser || ""}
                      onChange={(e) =>
                        handleInputChange(slabId, groupType, "apiuser", e.target.value)
                      }
                    />
                    <label className="form-label mt-2 mb-1">Gst %</label>
                    <input
                      type="number"
                      step="any"
                      className="form-control mt-2"
                      placeholder="GST %"
                      value={val.gst_percent || ""}
                      onChange={(e) =>
                        handleInputChange(slabId, groupType, "gst_percent", e.target.value)
                      }
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="page-wrapper">
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title mb-3">Commission Manager</h4>

              {renderTable("payin", "Payin Commission", "success")}
              {renderTable("payout", "Payout Charges", "danger")}

              <div className="text-end mt-3">
                <button
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save All"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Commission;
